export default {"src":"/_next/static/media/typescript.97711300.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};